import classNames from 'classnames';

import styles from './index.module.scss';

export type EvaTabItem = {
  readonly key: string;
  readonly label: string;
};

type Props = {
  readonly tabs: readonly EvaTabItem[];
  readonly activeKey: string;
  readonly onChange: (key: string) => void;
  readonly className?: string;
};

/** EVA 卡片内的页签条(登录方式 / 重置方式切换)。 */
const EvaTabs = ({ tabs, activeKey, onChange, className }: Props) => {
  return (
    <div className={classNames(styles.tabs, className)} role="tablist">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          type="button"
          role="tab"
          aria-selected={activeKey === tab.key}
          className={classNames(styles.tab, activeKey === tab.key && styles.active)}
          onClick={() => {
            onChange(tab.key);
          }}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default EvaTabs;
